<template>
  <div id="app">
    <!-- <HomePage /> -->
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import HomePage from './pages/HomePage.vue'

export default {
  name: 'App',
  components: {
    // HomePage
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
ul,li{
  list-style: none;
  padding: 0;
  margin: 0;
}
#app {
  font-family:  'Open Sans', sans-serif,'微软雅黑', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
.w100{
  width: 100%;
}
.w1024{
  width: 1200px;
  margin: auto;
}
.d-flex{
  display: flex;
}
.space-between{
  justify-content: space-between;
}
.space-around{
  justify-content:space-around;
  
}
.flex-column{
 flex-direction: column; 
}
.text-justify{
  text-align: justify;
}
.align-center{
  align-items: center;
}
.text-uppercase{
  text-transform: uppercase;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.pt-50{
  padding-top: 50px;
}
.pt-100{
  padding-top: 100px;
}
.fs-12{
  font-size: 12px;
}
.fs-14{
  font-size: 14px;
}
.plr20{
  padding-left: 20px;
  padding-right: 20px;
}
.mb50{
  margin-bottom: 50px;
}
.color-2{
  color: #000;
}
.pt-30{
  padding-top: 30px;
}
.color-1{
  color: #0547c2;
}
.color-fff{
  color: #ffffff;
}
.color-9{
  color: #939393;
}

.wf-b{
  font-weight:bold
}
.line-block{
background-color: #0547c2;
height: 2px;
width: 58px;
}
.fs-60{ font-size: 80px;}
.pd20{
  padding: 20px;
 
}
.ml-30{
  margin-left:30px
}
</style>
